import script from "./StatisticalContinue.vue?vue&type=script&setup=true&lang=ts"
export * from "./StatisticalContinue.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__